import React from "react";

const Footer = () => {
  return (
    <footer className="font-[Quicksand] bg-[#9CF0F4] text-gray-800 py-8 text-lg md:text-xl">
      {/* Wrapper max-width */}
      <div className="w-full max-w-6xl mx-auto px-2 md:px-4 flex flex-col md:flex-row md:justify-between gap-8">
        {/* Kiri */}
        <div className="space-y-2 md:w-2/3 leading-relaxed">
          <p>579a Canning Highway, Alfred Cove, Western Australia</p>
          <p className="text-gray-700">(Shop entry and parking at rear of shop)</p>
          <p>
            Open 8am to 5pm, Monday to Friday (Excluding Public Holiday).<br />
            <span className="font-semibold">0455 316 209</span>
          </p>
          <p>
            Follow us on Instagram and Facebook for behind-the-scenes, before & afters,
            and special offers.
          </p>
          <p className="pt-2 text-gray-600">
            © 2025 Furlissimo Dog Grooming. All rights reserved.
          </p>
        </div>

        {/* Kanan */}
        <div className="md:w-1/2 flex flex-col items-end text-right">
          <div className="flex items-center">
            {/* Bagian teks di kiri */}
            <div className="flex flex-col items-end mr-3 space-y-1">
              <a
                href="https://bookings.gettimely.com/furlissimoptyltd/bb/book"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-pink-600 text-lg md:text-xl hover:underline hover:text-pink-800 transition-colors"
              >
                Bookings
              </a>

              <p className="text-base md:text-lg">FAQ</p>
              <p className="text-base md:text-lg">Waiver</p>
            </div>

            {/* Emoji paw di kanan sejajar */}
            <div className="flex flex-col justify-center">
              <span className="text-3xl md:text-4xl mb-1">🐾</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
